import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'
import { AppShell } from '@liefersoft/pos-ui-core'
import SettingsPage from '../page/SettingsPage'
import ProductPage from '../page/Product'
import { Outlet, Route, Routes } from 'react-router-dom'
import LoginPage from '../page/Login'
import DiscountsPage from '../page/Discounts'
import PhonePage from '../page/Phone'
import PasswordLessPage from '../page/Login/PasswordLess'
import RecoveryPage from '../page/Recovery'
import RecoveryPasswordPage from '../page/Recovery/password'
import RegistrationCompanyPage from '../page/Registration/Company'
import UserPage from '../page/User'
import AuthChrome from '../component/AuthChrome'
import RequireCompanyRegistration from '../component/RequireCompanyRegistration'
import RequireReservationScope from '../component/RequireReservationScope'
import ThemeClassBridge from '../component/ThemeClassBridge'
import Language from '../component/Language'
import { useNavBarProps } from '../component/NavBar'
import TaxInfoMessage from '../component/Elements/TaxInfoMessage'
import VersionUpdater from '../component/Elements/versionUpdater'
import { SystemMessages } from '../App.styled'
import CompanyDataPage from '../page/CompanyData'
import ProgramSettingsPage from '../page/ProgramSettings'
import DriverMonitorPage from '../page/DriverMonitor'
import DesktopUserPage from '../page/DesktopUser'
import AllOrderPage from '../page/AllOrder'
import KitchenMonitorPage from '../page/KitchenMonitor'
import DeliveryConfigPage from '../page/DeliveryConfig'
import PermissionsPage from '../page/Permissions'
import PermissionsPageUsers from '../page/PermissionsUsers'
import DesktopClientPage from '../page/DesktopClient'
import ApiRestaurantPage from '../page/ApiRestaurant'
import TakeawayRestaurantPage from '../page/TakeawayRestaurant'
import RestaurantSettingsPage from '../page/RestaurantSettingsPage'
import IngredientsPage from '../page/Ingredients'
import LogOut from '../page/logout'
import ProcessDriverPage from '../page/ProcessDriver'
import OwnerRegistrationPage from '../page/Registration/Owner'
import CategoryPage from '../page/Category'
import PlatformsPage from '../page/Platforms'
import TaxSettingPage from '../page/TaxSettings'
import { lazyWithRetry } from '../helper/lazyWithRetry'
import OrdersmartRestaurantPage from '../page/OrdersmartRestaurant'
import CashDeskPage from '../page/CashDesk'
import HomePage from '../page/Home'
import ProductSettingsPage from '../page/ProductSettings'
import DeliverySettingsPage from '../page/DeliverySettings'
import DeliveryCartSettings from '../component/DeliveryCartSettings'
import CashDeskSettingsPage from '../page/CashDeskSettings'
import CashDeskCartSettings from '../component/CashDeskCartSettings'
import AreaPage from '../page/AreaPage'
import RestaurantCartSettingsPage from '../page/RestaurantCartSettingsPage'
import UberEatRestaurantPage from '../page/UberEatRestaurant'
import CashDrawerPage from '../page/CashDrawer'
import PrinterConfigPage from '../page/PrinterConfig'
import PrinterSettingsPage from '../page/PrinterSettings'
import Delivery from '../component/Delivery'
import DeliveryCart from '../component/Delivery/DeliveryCart'
import Restaurant from '../component/Restaurant'
import TableCart from '../component/Restaurant/TableCart'
import HelpPage from '../page/Help'
import RegistrationSuccessPage from '../page/RegistrationSuccessPage'
import CashBookSettingsPage from '../page/CashBookSetting'
import CategoriesOfCashBookPage from '../page/CategoriesOfCashBook'
import DateVSettingsPage from '../page/DateVSettings'
import WebShopSettingsPage from '../page/WebShopSettingPage'
import WoltRestaurantPage from '../page/WoltRestaurantPage'
import DailyStatistics from '../page/DailyStatistics'
import MonthlyStatistics from '../page/MonthlyStatistics'
import ReportPage from '../page/Report'
import ZReportPage from '../page/ZReport'
import DailyReportPage from '../page/DailyReport'
import MonthlyReportPage from '../page/MonthlyReport'
import DeliveryPage from '../page/Delivery'
import RestaurantPage from '../page/Restaurant'
import ToppingGroupsConfigPage from '../page/ToppingGroupsConfig'
import ToppingGroupsPage from '../page/ToppingGroups'
import ProductMenuPage from '../page/ProductMenu'
import MarketingSettingsPage from '../page/MarketingSettings'
import CouponPage from '../page/Coupon'
import CouponConfigPage from '../page/CouponConfig'
import ProductConfigPage from '../page/ProductConfig'
import CategoryConfigPage from '../page/CategoryConfig'
import PaymentsQrCodeSuccessPage from '../page/PaymentsQrCodeSuccess'
import PrinterConfigFormPage from '../page/PrinterConfigForm'
import FoodoraRestaurantPage from '../page/FoodoraRestaurantPage'
import PartnerPortalPage from '../page/PartnerPortal'
import PlatformDriversPage from '../page/DriverIntegrationPage'
import DeliveryWoltPage from '../page/DeliveryWoltPage'
import ClientMonitorSettingsPage from '../page/ClientMonitorSettings'
import KitchenMonitorSettingsPage from '../page/KitchenMonitorSettings'
import KitchenMonitorConfigPage from '../page/KitchenMonitorConfig'
import StampsSettingsPage from '../page/Stamps'
import FlyerCouponConfigPage from '../page/FlyerCouponConfig'
import WebShopTipsPage from '../page/WebShopTipsPage'
import WebShopPreOrdersPage from '../page/WebShopPreOrdersPage'
import RestaurantPushNotificationPage from '../page/RestaurantPushNotification'
import WoltIntegrationPage from '../page/WoltIntegration'
import PickupMonitor from '../component/PickupMonitor'
import PickupMonitorPage from '../page/PickupMonitor'
import MailingsConfigPage from '../page/MailingsConfig'
import InvoicesPage from '../page/Invoices'
import DiscountsConfigPage from '../page/DiscountsConfig'
import CategoryDiscountsPage from '../page/CategoryDiscounts'
import CategoryDiscountsConfigPage from '../page/CategoryDiscountsConfig'
import ProductSalesReportPage from '../page/ProductSalesReportPage'
import PartnerProductSalesReportPage from '../page/PartnerProductSalesReportPage'
import FranchiseProductSalesReportPage from '../page/FranchiseProductSalesReportPage'

const CashbookNew = lazyWithRetry(() => import(/* webpackChunkName: "cashbook-new" */'../component/Report/form/cashbookNew'))
const OnlinePlatformCoupons = lazyWithRetry(() => import(/* webpackChunkName: "coupon" */'../component/Coupon/OnlinePlatformCoupons'))
const ShopAppAdCoupons = lazyWithRetry(() => import(/* webpackChunkName: "coupon" */'../component/Coupon/ShopAppAdCoupons'))
const UniqueCoupons = lazyWithRetry(() => import(/* webpackChunkName: "coupon" */'../component/Coupon/UniqueCoupons'))
const GiftCoupons = lazyWithRetry(() => import(/* webpackChunkName: "coupon" */'../component/Coupon/GiftCoupons'))

const Layout = () => {
	const preloadedUserData = useSelector(store => store.login.user)
	const { Indicators, FooterSwitch, itemAddons, onWidthChange } = useNavBarProps()

	return (
		<>
			<RequireCompanyRegistration />
			<RequireReservationScope />
			<AppShell preloadedUserData={preloadedUserData}
								LocaleSwitch={<Language />}
								Indicators={Indicators}
								FooterSwitch={FooterSwitch}
								itemAddons={itemAddons}
								onWidthChange={onWidthChange}
								SystemMessages={<SystemMessages><TaxInfoMessage /><VersionUpdater /></SystemMessages>}>
				<ThemeClassBridge>
					<Outlet />
				</ThemeClassBridge>
			</AppShell>
		</>
	)
}

Layout.displayName = 'Layout'

const Main = React.memo(() => {
	return (
		<Routes>
			<Route element={<AuthChrome />}>
				<Route path="/*" element={<LoginPage />} />
				<Route path="/login/*" element={<LoginPage />} />
				<Route path="/registration/*" element={<OwnerRegistrationPage />} />
				<Route path="/registration/company/*" element={<RegistrationCompanyPage />} />
				<Route path="/registration/success" element={<RegistrationSuccessPage />} />
				<Route path="/recovery/*" element={<RecoveryPage />} />
				<Route path="/changepassword/:changePasswordId/*" element={<RecoveryPasswordPage />} />
				<Route path="/passwordless/:passwordLessCodeId/*" element={<PasswordLessPage />} />
				<Route path="/logout/*" element={<LogOut />} />
				<Route path="/payments/qr-code/success" element={<PaymentsQrCodeSuccessPage />} />
			</Route>

			<Route element={<Layout />}>
				<Route path="/home" element={<HomePage />} />
				<Route path="/help/*" element={<HelpPage />} />
				<Route path="/delivery/*" element={<DeliveryPage />}>
					<Route path="" element={<Delivery />} />
					<Route path="cart" element={<DeliveryCart />} />
					<Route path="pickup-monitor" element={<PickupMonitor />} />
				</Route>

				<Route path="/cashdesk" element={<CashDeskPage />} />
				<Route path="/cashdesk/pickup-monitor" element={<PickupMonitorPage />} />

				<Route path="/driver-monitor/*" element={<DriverMonitorPage />} />
				<Route path="/driver-monitor/driver/process/*" element={<ProcessDriverPage />} />
				<Route path="/kitchen-monitor/*" element={<KitchenMonitorPage />} />
				<Route path="/all-orders/*" element={<AllOrderPage />} />
				<Route path="/settings/*" element={<SettingsPage />} />
				<Route path="/restaurant/*" element={<RestaurantPage />}>
					<Route path="" element={<Restaurant />} />
					<Route path="cart" element={<TableCart />} />
				</Route>

				<Route path="/settings/product/ingredients/category/*" element={<CategoryPage />} />
				<Route path="/settings/product/ingredients/category/edit/*" element={<CategoryConfigPage />} />
				<Route path="/settings/product/category/printer/*" element={<CategoryPage />} />
				<Route path="/settings/product/category/image/*" element={<CategoryPage />} />

				<Route path="/settings/product/*" element={<ProductSettingsPage />} />
				<Route path="/settings/product/ingredients/article/*" element={<ProductPage />} />
				<Route path="/settings/product/ingredients/article/product/*" element={<ProductConfigPage />} />
				<Route path="/settings/product/ingredients/article/menu/*" element={<ProductMenuPage />} />
				<Route path="/settings/product/ingredients/*" element={<IngredientsPage />} />
				<Route path="/settings/product/ingredients/topping-groups/*" element={<ToppingGroupsPage />} />
				<Route path="/settings/product/ingredients/topping-groups/edit/*" element={<ToppingGroupsConfigPage />} />

				<Route path="/settings/program/printer/*" element={<PrinterSettingsPage />} />
				<Route path="/settings/program/printer/config/*" element={<PrinterConfigPage />} />
				<Route path="/settings/program/printer/config/edit/*" element={<PrinterConfigFormPage />} />
				<Route path="/settings/program/printer/cashdrawer/*" element={<CashDrawerPage />} />
				<Route path="/settings/program/phone/*" element={<PhonePage />} />
				<Route path="/settings/program/desktop/*" element={<DesktopUserPage />} />
				<Route path="/settings/program/*" element={<ProgramSettingsPage />} />
				<Route path="/settings/program/client-screen" element={<ClientMonitorSettingsPage />} />

				<Route path="/settings/program/company-data/*" element={<CompanyDataPage />} />
				<Route path="/settings/program/tax-settings/*" element={<TaxSettingPage />} />
				<Route path="/settings/program/users/*" element={<PermissionsPageUsers />} />
				<Route path="/settings/program/users/all/*" element={<UserPage />} />
				<Route path="/settings/program/users/permissions/*" element={<PermissionsPage />} />
				<Route path="/settings/program/platform/*" element={<PlatformsPage />} />
				<Route path="/settings/program/platform/takeaway/*" element={<TakeawayRestaurantPage />} />
				<Route path="/settings/program/platform/api/*" element={<ApiRestaurantPage />} />
				<Route path="/settings/program/platform/ordersmart/*" element={<OrdersmartRestaurantPage />} />
				<Route path="/settings/program/platform/ubereat/*" element={<UberEatRestaurantPage />} />
				<Route path="/settings/program/platform/wolt/*" element={<WoltRestaurantPage />} />
				<Route path="/settings/program/platform/wolt/integration/callback/*" element={<WoltIntegrationPage />} />
				<Route path="/settings/program/platform/foodora/*" element={<FoodoraRestaurantPage />} />

				<Route path="/settings/restaurant/*" element={<RestaurantSettingsPage />} />
				<Route path="/settings/restaurant/cart-settings/*" element={<RestaurantCartSettingsPage />} />
				<Route path="/settings/restaurant/areas/*" element={<AreaPage />} />
				<Route path="/settings/restaurant/push-notification/*" element={<RestaurantPushNotificationPage />} />

				<Route path="/settings/product/discounts/*" element={<DiscountsPage />} />
				<Route path="/settings/product/discounts/business/*" element={<DiscountsConfigPage />} />
				<Route path="/settings/product/discounts/category-discount/*" element={<CategoryDiscountsPage />} />
				<Route path="/settings/product/discounts/category-discount/edit/*" element={<CategoryDiscountsConfigPage />} />

				<Route path="/settings/delivery/*" element={<DeliverySettingsPage />} />
				<Route path="/settings/delivery/cart-settings/*" element={<DeliveryCartSettings />} />
				<Route path="/settings/delivery/config/*" element={<DeliveryConfigPage />} />

				<Route path="/settings/cashdesk/*" element={<CashDeskSettingsPage />} />
				<Route path="/settings/cashdesk/cart-settings/*" element={<CashDeskCartSettings />} />

				<Route path="/settings/cashbook/*" element={<CashBookSettingsPage />} />
				<Route path="/settings/cashbook/categories" element={<CategoriesOfCashBookPage />} />
				<Route path="/settings/datev" element={<DateVSettingsPage />} />

				<Route path="/settings/marketing" element={<MarketingSettingsPage />} />
				<Route path="/settings/marketing/coupon/*" element={<CouponPage />}>
					<Route path="online-platforms" element={<OnlinePlatformCoupons />} />
					<Route path="shop-app-ad" element={<ShopAppAdCoupons />} />
					<Route path="unique" element={<UniqueCoupons />} />
					<Route path="gift" element={<GiftCoupons />} />
				</Route>
				<Route path="/settings/marketing/coupon/config/*" element={<CouponConfigPage />} />
				<Route path="/settings/marketing/coupon/flyer-config/*" element={<FlyerCouponConfigPage />} />
				<Route path="/settings/marketing/stamps/*" element={<StampsSettingsPage />} />
				<Route path="/settings/marketing/mailings/*" element={<MailingsConfigPage />} />

				<Route path="/settings/webshop/*" element={<WebShopSettingsPage />} />
				<Route path="/settings/webshop/tips/*" element={<WebShopTipsPage />} />
				<Route path="/settings/webshop/pre-orders/*" element={<WebShopPreOrdersPage />} />

				<Route path="/settings/driver-integrations/*" element={<PlatformDriversPage />} />
				<Route path="/settings/driver-integrations/wolt/*" element={<DeliveryWoltPage />} />

				<Route path="/settings/kitchen-monitor" element={<KitchenMonitorSettingsPage />} />
				<Route path="/settings/kitchen-monitor/edit" element={<KitchenMonitorConfigPage />} />

				<Route path="/report/*" element={<ReportPage />}>
					<Route path="*" element={<ZReportPage />} />
					<Route path="daily" element={<DailyReportPage />} />
					<Route path="monthly" element={<MonthlyReportPage />} />
					<Route path="cashbook" element={<Suspense><CashbookNew /></Suspense>} />
				</Route>

				<Route path="report/daily/statistics/" element={<DailyStatistics />} />
				<Route path="report/monthly/statistics/" element={<MonthlyStatistics />} />

				<Route path="/desktop/client/*" element={<DesktopClientPage />} />

				<Route path="/partner-portal" element={<PartnerPortalPage />} />
				<Route path="/invoices" element={<InvoicesPage />} />

				<Route path="/office-reports/product-sales" element={<ProductSalesReportPage />} />
				<Route path="/partner-portal/office-reports/:companyIndex/product-sales" element={<PartnerProductSalesReportPage />} />
				<Route path="/franchise-portal/office-reports/:companyIndex/product-sales" element={<FranchiseProductSalesReportPage />} />

				<Route element={<h1>404</h1>} />
			</Route>
		</Routes>
	)
})

Main.displayName = 'Main'
export default Main
